import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_25: FaireProductEntity = {
  token: "legacy_prod_abbott-25",
  type: "product",
  name: 'Small Hanging Mouse Dark Brown 2" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3fac5d3d3837bf0e030a562d810202f2683a856a819e244746a393d11d4b6916.jpeg",
  priceDollars: 12,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
